module.exports = __webpack_public_path__ + "img/close-white.6db92857.svg";